import cloneDeep from "lodash/cloneDeep";
import type { State } from "~/types/store";

type Till = State["till"];
export type CompositionBaseline = NonNullable<Till["compositionBaseline"]>;

/**
 * Snapshot of the order as last saved (at hydration, then after each immediate
 * composition save). A deep copy, so a later in-place mutation of the live
 * slices cannot alter the saved source used by the next immediate change.
 */
export const createCompositionBaseline = ({
	prevItems,
	cancelled_items,
	note,
	customer,
}: Pick<
	Till,
	"prevItems" | "cancelled_items" | "note" | "customer"
>): CompositionBaseline =>
	cloneDeep({ prevItems, cancelled_items, note, customer });
